import React from "react";
import Navbar from "../../partials/Navber";
import Footer from "../../partials/Footer";
import CartModal from "../../partials/CartModal";

const sections = [
  {
    id: "nossa-historia",
    title: "Nossa História",
    content: `A Flitz nasceu com o propósito de redefinir o atacado esportivo no Brasil. Combinando eficiência logística, curadoria de produtos e atendimento estratégico, nos tornamos referência para lojistas que buscam confiança e crescimento constante.`,
  },
  {
    id: "missao-e-visao",
    title: "Missão e Visão",
    content: `Missão: Ser o elo entre marcas e lojistas, entregando performance e qualidade com excelência.

Visão: Ser a principal distribuidora esportiva do Brasil, reconhecida por sua integridade, inovação e comprometimento com resultados.`,
  },
  {
    id: "compromisso",
    title: "Compromisso com o Cliente",
    content: `Mais do que vender, entregamos valor. Nossa equipe está preparada para entender o seu negócio e oferecer soluções sob medida para impulsionar suas vendas e fortalecer sua marca no mercado.`,
  },
  {
    id: "diferenciais",
    title: "Diferenciais da Flitz",
    content: `• Agilidade logística e entrega para todo o Brasil
• Portfólio com marcas líderes e produtos exclusivos
• Atendimento consultivo e pós-venda ativo
• Relacionamento transparente e duradouro`,
  },
  {
    id: "nossos_produtos",
    title: "Nossos Produtos",
    content: `Oferecemos uma linha completa de artigos esportivos para diversas categorias: futebol, academia, treino funcional, acessórios, calçados e muito mais. Trabalhamos com foco na demanda real do varejo.`,
  },
  {
    id: "contato",
    title: "Fale Conosco",
    content: `Estamos à disposição para atender você. Entre em contato conosco pelo WhatsApp, e-mail ou redes sociais. Nossa equipe está pronta para ajudar no que for preciso. Com a Flitz, seu negócio vai mais longe.`,
  },
];

const SobreNos = () => {
  return (
    <>
      <Navbar />
      <main className="bg-white text-gray-800 min-h-screen mt-24 px-6 md:px-20 lg:px-40 py-12">
        <h1 className="text-4xl font-semibold mb-12 text-gray-900">Sobre a Flitz</h1>
        <div className="space-y-20">
          {sections.map((section) => (
            <section
              key={section.id}
              id={section.id}
              className="scroll-mt-24 border-b border-gray-200 pb-10"
            >
              <h2 className="text-2xl font-medium text-gray-900 mb-4">
                {section.title}
              </h2>
              <p className="text-base leading-relaxed whitespace-pre-line text-gray-700">
                {section.content}
              </p>
            </section>
          ))}
        </div>
      </main>
      <Footer />
      <CartModal />
    </>
  );
};

export default SobreNos;